var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"custom-your-field",class:{ passive: _vm.params.value === null }},[_vm._v("\n  "+_vm._s(_vm.getValue)+"\n  "),_c('span',{staticClass:"icon kw kw-chevron-down"})])}
var staticRenderFns = []

export { render, staticRenderFns }